module.exports = __webpack_public_path__ + "static/media/gen_img63.869ac577.png";